























import { Component, Vue, Prop } from 'vue-property-decorator';

import DateUtils from '@/utils/DateUtils';

import BillingService from '@/api/BillingService';
import eventBus from '@/utils/eventBus';

@Component({})
export default class TwismWalletBillingActivity extends Vue {
  @Prop(String) businessId!: string;

  billingService: BillingService = new BillingService();

  activities: Record<string, any>[] = [];
  loading: boolean = true;
  next: string = '';

  async getActivities() {
    this.loading = true;
    try {
      const { data } = await this.billingService.getTwismBillingActivity(
        this.businessId,
        this.next
      );

      const prepareData = data.map((activity: any) => ({
        ...activity,
        time: DateUtils.formatISOLongDate(activity.chargedAt, true)
      }));

      this.activities = prepareData;
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    await this.getActivities();

    eventBus.$on('reloadTwismWalletHistory', this.getActivities);
  }

  beforeDestroy() {
    eventBus.$off('reloadTwismWalletHistory', this.getActivities);
  }
}
